module.exports = __webpack_public_path__ + "img/ot1.dfc4b8d2.png";